var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskAssessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#0B0B17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9987 28.3099C17.2016 27.8488 16.6654 26.987 16.6654 26C16.6654 24.5272 17.8593 23.3333 19.332 23.3333C20.8048 23.3333 21.9987 24.5272 21.9987 26C21.9987 26.987 21.4624 27.8488 20.6654 28.3099V28.6666C20.6654 29.403 20.0684 30 19.332 30C18.5957 30 17.9987 29.403 17.9987 28.6666V28.3099Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9987 24.6666C25.9987 23.9302 26.5956 23.3333 27.332 23.3333C28.0684 23.3333 28.6654 23.9302 28.6654 24.6666C28.6654 25.403 28.0684 26 27.332 26C26.5956 26 25.9987 25.403 25.9987 24.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6602 19.5C28.6636 19.4449 28.6654 19.3893 28.6654 19.3333V14C28.6654 11.0544 26.2775 8.66663 23.332 8.66663H20.6654C17.7198 8.66663 15.332 11.0544 15.332 14V19.3333C15.332 19.3891 15.3338 19.4446 15.3372 19.5C13.0343 20.0902 11.332 22.1796 11.332 24.6666V29.9999C11.332 32.9455 13.7198 35.3333 16.6654 35.3333H24.3418C26.11 35.3333 27.8056 34.6309 29.0559 33.3806L30.7127 31.7238C31.963 30.4736 32.6654 28.7779 32.6654 27.0098V24.6666C32.6654 22.1797 30.9631 20.0903 28.6602 19.5ZM25.9987 19.3333H17.9987V14C17.9987 12.5272 19.1926 11.3333 20.6654 11.3333H23.332C24.8048 11.3333 25.9987 12.5272 25.9987 14V19.3333ZM27.1703 31.495C26.4201 32.2452 25.4027 32.6666 24.3418 32.6666H16.6654C15.1926 32.6666 13.9987 31.4727 13.9987 29.9999V24.6666C13.9987 23.1939 15.1926 22 16.6654 22L27.332 22C28.8048 22 29.9987 23.1939 29.9987 24.6666V27.0098C29.9987 28.0706 29.5773 29.088 28.8271 29.8382L27.1703 31.495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAssessing);
export default __webpack_public_path__ + "static/media/risk-assessing.2e587fe0fd098b9dafd343395ff9eead.svg";
export { ForwardRef as ReactComponent };